import React from 'react';
import { Box, Typography, Divider, Chip } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const ApproversInfo = ({ approvers }) => {
  if (!approvers || approvers.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 2, p: 2, bgcolor: 'rgba(232, 244, 253, 0.6)', borderRadius: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
        אושר על ידי:
      </Typography>
      <Divider sx={{ mb: 1.5 }} />
      
      {approvers.map((approver, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <CheckCircleOutlineIcon sx={{ color: 'success.main', mr: 1 }} />
          <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
            {approver.name}
          </Typography>
          {approver.date && (
            <Chip 
              size="small" 
              label={approver.date} 
              sx={{ ml: 1, backgroundColor: 'rgba(76, 175, 80, 0.1)' }} 
            />
          )}
        </Box>
      ))}
    </Box>
  );
};

export default ApproversInfo;